import { FC, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'

import {
	Button,
	Container,
	Form,
	SpaceBetween,
	Textarea
} from '@cloudscape-design/components'

import { PlatformRejectionRequest } from '../../../types/platforms'
import useRejectPlatform from '../../../hooks/mutate/useRejectPlatform'

interface RejectionFormProps {
	thisPlatformID: string
	shouldShowRejectionForm: (shouldShow: boolean) => void
}

const RejectionForm: FC<RejectionFormProps> = ({
	thisPlatformID,
	shouldShowRejectionForm
}) => {
	const { authState } = useOktaAuth()
	const thisUserEmail = authState?.idToken?.claims.email as string

	const [commentText, setCommentText] = useState('')

	const { mutate: rejectPlatform, isLoading } =
		useRejectPlatform(thisPlatformID)

	const _handleReject = () => {
		const rejectionRequest: PlatformRejectionRequest = {
			action: 'REJECT',
			platformID: thisPlatformID,
			commenterID: thisUserEmail,
			comment: commentText
		}

		rejectPlatform(rejectionRequest, {
			onSuccess: () => {
				shouldShowRejectionForm(false)
				setCommentText('')
			}
		})
	}

	return (
		<Form
			actions={
				<SpaceBetween direction="horizontal" size="xs">
					<Button variant="link" onClick={() => shouldShowRejectionForm(false)}>
						Cancel
					</Button>
					<Button variant="primary" loading={isLoading} onClick={_handleReject}>
						Reject
					</Button>
				</SpaceBetween>
			}
		>
			<Container>
				<SpaceBetween direction="vertical" size="l">
					<Textarea
						onChange={({ detail }) => setCommentText(detail.value)}
						value={commentText}
						placeholder="Reason for rejection"
					/>
				</SpaceBetween>
			</Container>
		</Form>
	)
}

export default RejectionForm
